import { AutorisationApiClient } from "@/features/user/authorization/api-client/autorisation-api-client.ts";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CheckAuthorizationResponse } from "../types";

export const useAuthorization = () => {
  const queryClient = useQueryClient();
  function useCheckAuthorizationMutation() {
    return useMutation<CheckAuthorizationResponse, Error, string>({
      mutationFn: async (identityUuid: string) =>
        AutorisationApiClient.saveRequestAccount(identityUuid),
      onSettled: () => queryClient.invalidateQueries({ queryKey: ["user", "profile"] })
    });
  }

  return {
    useCheckAuthorizationMutation
  };
};
